import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./layouts/Layout";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import { ToastContainer } from "react-toastify";
import GeofenceIndex from "./pages/Geofence/Index";
import GeofenceAdd from "./pages/Geofence/Add";
import ManageProductIndex from "./pages/ManageProduct/ManageProduct";
import ProfileIndex from "./pages/Profile/ProfileIndex";
import Enquiries from "./pages/Enquiry";
import Supplier from "./pages/Supplier";
import Home from "./pages/Home";
import Register from "./pages/Register";
import { useSelector } from "react-redux";
import ProductDetails from "./pages/ProductDetails";
import ForgotPassword from "./pages/auth/ForgotPassword";

const AppRoutes = () => {
  const { AuthReducer: { loading, errors, isAuthenticated } } = useSelector(state => state)

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {isAuthenticated ?
          // <Route path="/supplier" element={<Supplier />} />
          <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          </Route>
          :
          <Route path="/" element={<Home />} />
        }


        <Route path="/supplier-products/:id" element={<ProductDetails />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/supplier/:id" element={<Supplier />} />
        <Route element={<Layout />}>
          <Route path="/Profile" element={<ProfileIndex />} />
          <Route path="/Geofence" element={<GeofenceIndex />} />
          <Route path="/Add-Geofence" element={<GeofenceAdd />} />
          <Route path="/Update-Geofence/:id" element={<GeofenceAdd />} />
          <Route path="/Manage-Product" element={<ManageProductIndex />} />
          <Route path="/Enquiries" element={<Enquiries />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
